var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
// we need to import directly from here due to circular references
import { FormattedMessage } from "react-intl-phraseapp";
import ErrorText from "@irati/ui/src/ErrorText";
import { getErrorMessage } from "../../../lang/formatError";
var LoadingError = function (props) {
    var networkError = props.apollo.error.networkError;
    var _a = props.errorMsg, errorMsg = _a === void 0 ? getErrorMessage(props.apollo.error) : _a;
    return (React.createElement(ErrorText, __assign({}, props),
        React.createElement(FormattedMessage, { id: errorMsg, values: networkError.errorData })));
};
export default LoadingError;
